var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.items),function(item,i){return _c('span',{key:i,class:{
      'breadcrumbs__breadcrumb': true,
      'breadcrumbs__breadcrumb--active': i === _vm.lastBreadcrumbIndex
    },on:{"click":function($event){item.click && item.click()}}},[(i > 0)?_c('i',{staticClass:"fas fa-chevron-right breadcrumbs__breadcrumb-icon"}):_vm._e(),_c('span',{class:{
        'text-green': i !== _vm.lastBreadcrumbIndex
      }},[_vm._v(_vm._s(item.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }